// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
	var navToggle = document.querySelector('.navbar-toggler');

	// Add a 'click' event listener to the button
	navToggle.addEventListener('click', function () {
		// Code to be executed when the button is clicked
		console.log('Navigation toggle clicked');
	});
	console.log('#######');
	document.addEventListener('DOMContentLoaded', function() {

		var button = document.querySelector('.navbar-toggler');
		console.log('---> ', button);

		if (button) {
			button.addEventListener('click', function() {
				console.log('Button clicked');
			});
		} else {
			console.log('Button not found');
		}
	});
})();

